import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/storage';
import 'firebase/auth';
import 'firebase/functions';
import config from 'src/config';
try {
    var firebaseConfig = {
        apiKey: config.firebase.apiKey,
        authDomain: config.firebase.authDomain,
        databaseURL: config.firebase.databaseURL,
        projectId: config.firebase.projectId,
        storageBucket: config.firebase.storageBucket,
        messagingSenderId: config.firebase.messagingSenderId
    };
    firebase.initializeApp(firebaseConfig);
}
catch (error) {
    console.log(error);
}
// - Storage reference
export var storageRef = firebase.storage().ref();
// Initialize Cloud Firestore through Firebase
var db = firebase.firestore();
var settings = { timestampsInSnapshots: true };
// const settings = {timestampsInSnapshots: true, host: 'localhost:8081',
// ssl: false}
db.settings(settings);
export { db };
// - Database authorize
export var firebaseAuth = firebase.auth;
export var functions = firebase.functions();
// export let firebaseRef = firebase.database().ref()
// - Firebase default
export default firebase;



//////////////////
// WEBPACK FOOTER
// ./src/data/firestoreClient/index.ts
// module id = 30
// module chunks = 50